export const defaultFaviconUrl: string = `https://static.group.app/groups/favicons/mhrwdG6xwUg1GVgU69dtJtwT9yEcPNhwlEwgsMLe.png`